import { colors } from 'pages/new-questions/styles/common';
import styled, { css } from 'styled-components';

export const AnswersStyled = styled.div`
  display: flex;
  flex-direction: column;
  gap: 14px;
  width: 100%;

  @media screen and (max-width: 768px) {
    font-size: 14px;
  }
`;

type AnswerStyledProps = {
  checked?: boolean;
  correct?: boolean;
  incorrect?: boolean;
};

export const AnswerStyled = styled.div<AnswerStyledProps>`
  width: 100%;
  min-height: 54px;
  gap: 10px;
  padding: 12px 16px;
  border-radius: 8px;
  border-width: 1px;
  display: flex;
  align-items: center;
  align-self: stretch;
  background-color: ${colors.bgGray};
  cursor: pointer;
  border: 1px solid ${colors.white};
  color: ${colors.black};

  &.answered {
    cursor: not-allowed;
    pointer-events: none;
  }

  ${({ checked, correct, incorrect }) => {
    if (correct) {
      return css`
        border: 1px solid ${colors.green};
        background-color: ${colors.greenBackground};
      `;
    } else if (checked && incorrect) {
      return css`
        border: 1px solid ${colors.red};
        background-color: ${colors.redBackground};
      `;
    } else if (checked) {
      return css`
        border: 1px solid ${colors.primary};
        background-color: ${colors.primaryBackground};
      `;
    }
  }}
`;

export const AnswerContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 10px;
  flex: 1;
  min-width: 0;
`;

export const AnswerImage = styled.img`
  max-width: 100%;
  max-height: 180px;
  object-fit: contain;
  border-radius: 4px;
`;

export const ResultOptionIcon = styled.div`
  min-width: 32px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50px;
  background: ${colors.white};
  color: ${colors.black};
  font-weight: 600;
  font-size: 14px;
  text-transform: uppercase;
  position: relative;
  gap: 2px;
  padding: 0 8px;

  &.is-correct {
    min-width: 46px;
    background: ${colors.green};
    color: ${colors.white};
  }

  &.is-incorrect {
    min-width: 46px;
    background: ${colors.red};
    color: ${colors.white};
  }

  &.is-correct-answer {
    min-width: 46px;
    background: ${colors.green};
    color: ${colors.white};
  }

  &.is-selected {
    background: ${colors.primary};
    color: ${colors.white};
  }
`;
